export const moduleName = 'authentication'

export type AuthenticationState = {
  isStaffUser: boolean | null
  authInitialized: boolean
}
